<template>
<!--    <div id="customerService">
        &lt;!&ndash;智能客服&ndash;&gt;
        <div @click="showCustomerService = true" class="service">
            <img src="../../assets/img/service.png">
            <p>智能客服</p>
        </div>
        <div>
            <a-modal
                    title="信易贷智能客服"
                    :visible="showCustomerService"
                    :footer="null"
                    @cancel="showCustomerService = false"
            >
                <iframe
                        allow="microphone"
                        width="100%"
                        height="430"
                        style="border: 0;"
                        src="https://tbp.cloud.tencent.com/tbp-h5-v2/?AgentId=N78%2FlUSx7JSwaA%2BjQBt1GcCPuAvyCno4NLamgN%2F9Pmis4KUkrWBDAJ74KBKLUi4pIHd10xudzsxELI99yYfwo1buamA7HYgoOOz%2Bax4Vz2U%3D&ufc=&ubc=&bfc=&bbc=&tfc=&tbc=">
                </iframe>
            </a-modal>
        </div>
    </div>-->
</template>

<script>
export default {
    name: "customerService",
    data() {
        return {
            showCustomerService: false,
        }
    }
}
</script>

<style scoped>
    .service {
        display: inline-block;
        width: 140px;
        position: fixed;
        right: 23px;
        top: 80%;
        z-index: 99;
        text-align: center;
    }

    .service img {
        width: 70px;
        margin-bottom: 5px;
    }

    .service p {
        color: #1296db;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
    }
</style>
